<script lang="ts">
  import { debounce } from "lodash-es";
  import { pageState, searchByQuery, searchText } from "state/page";
  import { getMimirSearchQuery } from "state/queries/mimir";

  const mimirQuery = getMimirSearchQuery();

  let inputEl: HTMLInputElement;

  const handleSearch = debounce((event: Event) => {
    if (event.target instanceof HTMLInputElement) {
      searchByQuery(event.target.value);
    }
  }, 300);

  const handleSearchOnEnter = debounce((event: KeyboardEvent) => {
    if (event.key === "Enter") {
      if (event.target instanceof HTMLInputElement) {
        searchByQuery(event.target.value);
      }
    }
  }, 300);

  function handleSubmit() {
    handleSearch.cancel();
    handleSearchOnEnter.cancel();
    searchByQuery(inputEl.value);
    $mimirQuery.refetch();
  }
  function setFocusInViewport(node: HTMLElement){
    const observer = new IntersectionObserver((entries) => {
      if (entries[0]?.isIntersecting) {
        inputEl?.focus();
        observer.disconnect();
      }
    });
    observer.observe(node);
    return { destroy: () => observer.disconnect() };
  }
</script>

<div class="search-bar">
  <form
    role="search"
    on:submit|preventDefault={handleSubmit}
    aria-label="Fritekstsøk"
  >
    <span class="org-sr">Søk etter bilde</span>
    <!-- svelte-ignore a11y-autofocus -->
    <input
      bind:this={inputEl}
      class="org-input"
      type="text"
      name="search"
      use:setFocusInViewport
      autofocus={$pageState.type === "SEARCH"}
      placeholder="Søk etter bilde..."
      on:keyup|preventDefault={$pageState.type === "SEARCH" ? handleSearch : handleSearchOnEnter}
      value={$searchText}
      data-testid="search-bar"
    />
  </form>
</div>

<style>
  .search-bar {
    display: flex;
    margin: 0 var(--org-small);
    align-items: center;
    flex: 1;
    min-width: 300px;
    max-width: 800px;
  }

  form {
    width: 100%;
  }

  @media (max-width: 768px) {
    .search-bar {
      order: 1;
      flex-basis: 100%;
      max-width: none;
      margin: 0 0 var(--org-small) 0;
    }
  }
</style>
